import { NavLink } from 'react-router-dom';
import IconList from '@/ui/components/IconList';
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';

interface OptionFooterProps {
    title: string;
    to?: string;
    hadleFunction?: () => void;
}
/** Renderiza Opciones para el footer
 * @component
*/
const OptionFooter = ({ title, to, hadleFunction }: OptionFooterProps): JSX.Element => {
    const buttonVariant = getCSSVariableValue('--link-button-variant-footer');
    const navLinkProps = {
        onClick: hadleFunction
            ? (e: React.MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault();
                hadleFunction();
            }
            : undefined,
        to: to || '#',
    };
    return (
        <div>
            <NavLink
                className={`svg-primary-4`}
                to={navLinkProps.to}
                onClick={navLinkProps.onClick}
            >
                <IconList
                    iconName=''
                    classMain={`${buttonVariant} py-2`}
                    title={title}
                />
            </NavLink>
        </div>
    )
}

export default OptionFooter;